export class Availabilities {
    public static ALL = 'ALL';
    public static TOGO = 'TOGO';
    public static IN_HOUSE = 'IN_HOUSE';
    public static NONE = 'NONE';
}
